exports.components = {
  "component---src-components-home-tsx": () => import("./../../../src/components/home.tsx" /* webpackChunkName: "component---src-components-home-tsx" */),
  "component---src-components-post-jsx": () => import("./../../../src/components/post.jsx" /* webpackChunkName: "component---src-components-post-jsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */)
}

